<mmoga-enterprise-access-areas [enterpriseId]="enterpriseId"></mmoga-enterprise-access-areas>

<div class="card" *ngIf="isRcmAiPlatformEnabled">
    <div class="card-header mm-card-header">
        RCM AI Platform
    </div>
    <div class="card-body col-md-12">
        <p-table data-identifier="applications-table"
                 [value]="tableData"
                 [lazy]="true"
                 [lazyLoadOnInit]="false"
                 (onLazyLoad)="lazyLoad($event)"
                 [sortField]="sortBy"
                 [sortOrder]="sortOrder === 'DESC' ? -1 : 1"
                 [totalRecords]="totalItems"
                 [scrollable]="true"
                 scrollHeight="650px"
                 [loading]="isLoading">
            <ng-template pTemplate="header">
                <tr>
                    <th class="col-select">
                        <input type="checkbox"
                               [checked]="isCurrentPageAllSelected()"
                               (change)="toggleCurrentPage($any($event.target).checked)">
                    </th>
                    <th class="col-sites" pSortableColumn="organization.urlPrefix">
                        Sites
                        <p-sortIcon field="organization.urlPrefix"></p-sortIcon>
                    </th>
                    <th class="col-fgi">
                        FGI
                        <span class="tooltip-icon pe-1"
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              title="Firm Global Identifier">
                            <fa-icon [icon]="faInfoCircle"></fa-icon>
                        </span>
                    </th>
                    <th class="col-enterprise-login">
                        {{ enterpriseLabels.universalIdLabel }}
                        <span class="tooltip-icon pe-1"
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              [title]="universalIdColumnTooltip">
                            <fa-icon [icon]="faInfoCircle"></fa-icon>
                        </span>
                    </th>
                    <th class="col-status">Status</th>
                    <th class="col-enabled text-end">Actions</th>
                </tr>
                <tr *ngIf="selectedIds.size > 0">
                    <th colspan="6" class="p-2 col-selection-banner">
                        <div class="alert alert-info d-flex justify-content-between align-items-center mb-0 py-2 px-3 rounded-3">
                            <div class="d-flex align-items-center gap-2">
                                <span>
                                    <strong>{{ selectedIds.size }} {{ selectedIds.size === 1 ? 'Site' : 'Sites' }}</strong> selected.
                                </span>
                                <button *ngIf="!allPagesSelected" class="btn btn-link fw-semibold p-0" (click)="selectAllPages()">
                                    {{ totalItems === 1 ? 'Select the Site' : 'Select all ' + totalItems + ' sites' }}.
                                </button>
                                <button *ngIf="allPagesSelected" class="btn btn-link fw-semibold p-0" (click)="clearSelection()">
                                    {{ totalItems === 1 ? 'Deselect the Site' : 'Deselect all ' + totalItems + ' sites' }}.
                                </button>
                            </div>
                            <div class="d-flex align-items-center gap-2">
                                <button class="btn btn-sm btn-default rounded-pill"
                                        [disabled]="isUpdating"
                                        (click)="onBulkDisable()">
                                    <fa-icon [icon]="faPowerOff" class="me-1"></fa-icon> Disable
                                </button>
                                <button class="btn btn-sm btn-default rounded-pill"
                                        [disabled]="isUpdating"
                                        (click)="onBulkEnable()">
                                    <fa-icon [icon]="faCircleCheck" class="me-1"></fa-icon> Enable
                                </button>
                            </div>
                        </div>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item>
                <tr>
                    <td>
                        <input type="checkbox"
                               [checked]="selectedIds.has(item.organizationId)"
                               [disabled]="!isRowSelectable(item)"
                               (change)="toggleRow(item, $any($event.target).checked)">
                    </td>
                    <td data-identifier="site-url">{{ item.siteUrl }}</td>
                    <td data-identifier="fgi">{{ item.globalIdentifier }}</td>
                    <td data-identifier="enterprise-login">
                        <span *ngIf="isEnterpriseLoginEnabled(item)" class="text-success">
                            <fa-icon [icon]="faCircleCheck" class="me-1"></fa-icon>Enabled
                        </span>
                        <span *ngIf="!isEnterpriseLoginEnabled(item)" class="text-muted">Not Enabled</span>
                    </td>
                    <td data-identifier="status">{{ isRcmEnabled(item) ? 'Enabled' : 'Disabled' }}</td>
                    <td data-identifier="action" class="text-end">
                        <lib-tooltip [tooltipText]="toggleTooltip(item) || undefined">
                            <button class="btn btn-sm"
                                    [ngClass]="isRcmEnabled(item) ? 'btn-outline-danger' : 'btn-outline-primary'"
                                    [disabled]="isToggleDisabled(item)"
                                    (click)="onToggleFirmStatus(item)">
                                {{ isRcmEnabled(item) ? 'Disable' : 'Enable' }}
                            </button>
                        </lib-tooltip>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr data-identifier="no-records">
                    <td [attr.colspan]="6">
                        <lib-empty-state />
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="footer">
                <tr data-identifier="table-footer">
                    <td [attr.colspan]="6">
                        <lib-pagination *ngIf="totalItems > 0"
                                        #pagination
                                        [totalItems]="totalItems"
                                        [currentPage]="currentPage"
                                        (selectItemsPerPage)="onSelectItemsPerPage($event)"
                                        (changeCurrentPage)="onChangeCurrentPage($event)">
                        </lib-pagination>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
